import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import axios from 'axios'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import zhLocale from 'iview/src/locale/lang/zh-CN'
import enLocale from 'iview/src/locale/lang/en-US'
import cn from './language/zh_CN'
import us from './language/en_US'
import VueI18n from 'vue-i18n'

// import style
import 'swiper/css/swiper.css'
const messages = {
  zh: Object.assign(cn, zhLocale),
  en: Object.assign(us, enLocale)

}
Vue.use(VueI18n)
Vue.locale = () => {}
Vue.use(VueAwesomeSwiper /* { default options with global component } */)
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh', // set locale
  messages // set locale messages
})
// router.beforeEach((to, from, next) => {
//   console.log(to + '蔺' + from)
// })
// axios.interceptors.response.use(config => {
//   let authorization = localStorage.authorization
//   config.headers.Authorization = 'Bearer ' + authorization
//   return config
// }, function (error) {
//   return Promise.reject(error)
// })
// axios.interceptors.request.use(config => {
//   let authorization = localStorage.authorization
//   config.headers.Authorization = 'Bearer ' + authorization
//   return config
// }, function (error) {
//   return Promise.reject(error)
// })
Vue.use(iView)
Vue.prototype.$staticUrl = 'http://www.iformats.cn'
Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
